import { render, staticRenderFns } from "./ConsultaProdutoTable.vue?vue&type=template&id=463aad16"
import script from "./ConsultaProdutoTable.vue?vue&type=script&lang=js"
export * from "./ConsultaProdutoTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports